export const sortByLastMessageDateDesc = (a, b) =>
  new Date(b.lastMessageDate) - new Date(a.lastMessageDate);